<template>
  <base-material-card :icon="resource.icon" :title="title">
    <va-list :filters="filters">
      <va-data-table :fields="fields" disable-clone>
        <template #[`field.id`]="{ value }">
          <span class="monospaced-text">{{ value }}</span>
        </template>
        <template #[`field.key`]="{ value }">
          <span :title="value" style="word-break: break-all">{{ truncateLongText(value, keyTruncateConfig) }}</span>
          <v-icon
            v-clipboard="value"
            v-clipboard:success="clipboardSuccessHandler"
            x-small
            style="cursor: pointer"
            class="ml-1"
          >
            mdi-content-copy
          </v-icon>
        </template>
        <template #[`field.language`]="{ value }">
          {{ getLanguageByISOCode(value) }}
        </template>
        <template #[`field.lastUpdatedAt`]="{ value }">
          {{ new Date(value).toLocaleDateString('en-CA') }}
        </template>
      </va-data-table>
    </va-list>
  </base-material-card>
</template>

<script>
import { defaultLanguages } from '@/foundations/helpers/defaultLanguages';
import eventBus from '@/foundations/services/eventBus';
import truncateLongText from '@/mixins/truncateLongText';

export default {
  mixins: [truncateLongText],
  props: {
    title: {
      type: String,
      default: '',
    },
    resource: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        {
          source: 'id',
          link: 'edit',
          sortable: true,
        },
        {
          source: 'key',
          sortable: true,
        },
        {
          source: 'sourceType',
          attributes: {
            chip: true,
            color: 'orange',
          },
          sortable: true,
        },
        {
          source: 'state',
          attributes: {
            chip: true,
            color: 'orange',
          },
          sortable: true,
        },
        { source: 'language', sortable: true },
        {
          source: 'lastUpdatedAt',
          sortable: true,
        },
      ],
      filters: [
        'key',
        {
          source: 'sourceType',
          type: 'select',
          attributes: {
            multiple: true,
          },
        },
        {
          source: 'language',
          type: 'select',
          attributes: {
            multiple: true,
            choices: defaultLanguages,
          },
        },
        {
          source: 'state',
          type: 'select',
          attributes: {
            multiple: true,
          },
        },
        {
          source: 'lastUpdatedAt',
          type: 'date',
        },
      ],
      keyTruncateConfig: {
        xs: 25,
        sm: 25,
        md: 30,
      },
    };
  },
  methods: {
    getLanguageByISOCode(code) {
      return defaultLanguages.find((language) => language.value === code)?.text ?? code;
    },
    clipboardSuccessHandler() {
      eventBus.$emit('snackbar.open', 'Key has been copied successfully!');
    },
  },
};
</script>

<style>
.monospaced-text {
  font-family: monospace;
}
</style>
